const NewsLetterTypeForm = ({formKey}: {formKey: string}) => {
  return <div data-tf-live={formKey}></div>;
};

export default NewsLetterTypeForm;
